import React, { useContext } from "react";
import { Flex, Layout } from "antd";
import {
	HeaderComp,
	TwoColumnsTextLeft,
	TwoColumnsTextRight,
	CarouselComp,
	FooterComp
} from "../../../components";
import useIsMobile from '../../../utils/isMobile'
import { LangContext } from "../../../utils/LanguageProvider";
import FullCustomHtml from "components/FullCustomHtml";
import { PartnerForm } from "../../../components/Forms";

const { Header, Content, Footer } = Layout

const FraudRisk = () => {
	const { lang } = useContext(LangContext);
	const isMobile = useIsMobile();
	return (
		<>
			<Header>
				<div className="header-container">
					<HeaderComp />
				</div>
			</Header>
			<div className="full-container">
				<Flex vertical style={{ maxWidth: '1400px', width: '100%' }}>
					<Content className="global-content">
						<TwoColumnsTextLeft page={"partnerships"} section={"twocolumnstextleft-hero"} lang={lang} />
                        <TwoColumnsTextRight page={"partnerships"} section={"twocolumnstextright"} lang={lang} />
                        <TwoColumnsTextLeft page={"partnerships"} section={"twocolumnstextleft-accordion"} comp={'Accordion'} lang={lang} />
						
						<CarouselComp page={"partnerships"} section={"carousell"} type={'smallCards'} lang={lang} />
						{/* <CarouselComp page={"partnerships"} section={"carousell"} type={'largeCards'} lang={lang} /> */}
						<FullCustomHtml page={"partnerships"} section={"fullcustomhtml-form"} lang={lang} />
						{/* <CarouselComp page={"partnerships"} section={"postlist"} type={'posts'} lang={lang} numPosts={10} categoryName={'testimonial'}/> */}
						{/* <PartnerForm /> */}
					</Content>
				</Flex>
			</div>
			<Footer>
				<FooterComp page={'sobre-payretailers'} lang={lang} />
			</Footer>
		</>
	);
};

export default FraudRisk;
